import { useState } from "react";
import CompletedReports from "./reports/CompletedReports";
import RecheckReports from "./reports/RecheckReports";
import {
  dummyData_finalReport,
  dummyData_recheckReport,
} from "../../../core/data/js/dummy-data";

export const ReportStats = [
  {
    value: "completed_reports",
    label: "Final Reports",
    // label: "Completed Reports",
    count: dummyData_finalReport?.length || 0,
    component: <CompletedReports />,
  },
  {
    value: "recheck_reports",
    label: "Reverification Reports",
    // label: "Recheck Reports",
    count: dummyData_recheckReport?.length || 0,
    component: <RecheckReports />,
  },
];

// const guide_content: Record<string, any> = {
//   completed_reports: {
//     title: "Completed Reports",
//     content:
//       "Any case/check which requires a modification should be resent to Aupertz. Any minor issues/type error to be classified as a rejection which will only lead to changes in the existing report. And will be amended and sent to you. If you would like us to re-verify or re-process the check with new information it should be classified as completed.",
//   },
//   recheck_reports: {
//     title: "Recheck Reports",
//     content:
//       "Any case/check which requires a modification should be resent to Aupertz. Any minor issues/type error to be classified as a rejection which will only lead to changes in the existing report. And will be amended and sent to you. If you would like us to re-verify or re-process the check with new information it should be classified as recheck.",
//   },
// };

type Props = {
  status_id: string
}

const Reports: React.FC<Props> = ({ status_id }) => {
  const [activeTab, setActiveTab] = useState<string>(ReportStats[0]?.value);
  const activeItem = ReportStats.find((i) => i.value == activeTab);
  const activeComponent = activeItem ? activeItem.component : <></>;

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });

  const [showGuide, setShowGuide] = useState<boolean>(false);



  return (
    <>
      {/* Guide Container */}
      {/* <>
        <div className="text-end">
          <Button
            className="border-secodary"
            onClick={() => setShowGuide((prev) => !prev)}
          >
            <i className="ti ti-info-circle-filled fs-16"></i>
            <div className="pb-1 ">Guide</div>
          </Button>
        </div>

        <GuideContentArea
          maxHeight={"180px"}
          showGuide={showGuide}
          handleClick={() => setShowGuide(false)}
          title={guide_content[activeTab].title}
          content={<div>{guide_content[activeTab].content}</div>}
        />
      </> */}

      {/* Summary/Stat Cards */}
      <div className="mt-3 px-3 py-4 bg-subtle rounded-3 shadow-sm bg-white">
        <div
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "none",
          }}
        >
          <div
            className="d-flex flex-nowrap gap-2 pb-0 px-1 mb-0"
            style={{ width: "max-content", minWidth: "100%" }}
          >
            {ReportStats?.map((itm, idx) => (
              <div
                key={itm.value}
                className={`flex-grow-1 text-center rounded-3`}
                style={{ minWidth: 130 }}
              >
                <button
                  type="button"
                  className={`btn rounded-3 w-100 p-3 ${itm.value == activeTab ? "btn-primary text-white" : "border"} `}
                  onClick={() => {
                    setActiveTab(itm.value);
                  }}
                >
                  <p className="fw-bold mb-1">{itm.label}</p>
                  <span>{itm.count}</span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="mt-4">{activeComponent}</div>
    </>
  );
};

export default Reports;
